import type { Entitlement } from '@/types/Entitlement'
import type { UUID } from '@/types/Id'

/**
 * MCP server_name → entitlements required to enable (org needs at least one).
 * Servers not listed here have no entitlement requirement.
 */
export const SERVER_ENTITLEMENTS: Partial<Record<string, Entitlement[]>> = {
  microsoft: ['microsoft_mcp_managed', 'microsoft_mcp_custom'],
  salesforce: ['salesforce'],
}

interface MCPServersQueryKeyArgs {
  orgId: UUID | ''
}

export const availableMcpServersQueryKeys = {
  all: () => ['available-mcp-servers'] as const,
  organization: (keyArgs: MCPServersQueryKeyArgs) =>
    ['available-mcp-servers', keyArgs.orgId] as const,
}

export const enabledMcpServersQueryKeys = {
  all: () => ['enabled-mcp-servers'] as const,
  organization: (keyArgs: MCPServersQueryKeyArgs) =>
    ['enabled-mcp-servers', keyArgs.orgId] as const,
}

export type MicrosoftNationalCloud = 'commercial' | 'gcc' | 'gcc_high'

export const MICROSOFT_CLOUD_OPTIONS: {
  value: MicrosoftNationalCloud
  label: string
}[] = [
  { value: 'commercial', label: 'Commercial' },
  { value: 'gcc', label: 'GCC' },
  { value: 'gcc_high', label: 'GCC High' },
]

/** Which clouds each credential mode supports */
export const MICROSOFT_CREDENTIAL_CLOUDS: Record<
  'managed' | 'custom',
  MicrosoftNationalCloud[]
> = {
  managed: ['commercial', 'gcc'],
  custom: ['commercial', 'gcc', 'gcc_high'],
}
